import React from 'react';
import { Alert, AlertTitle, CircularProgress, IconButton, Paper, Tooltip, Typography } from '@mui/material';

import { Icon, useSettings } from 'app/main/components';

interface CreditsafeLinkSectionProps {
	linkCreditsafeCompany: VoidFunction;
	isLoading?: boolean;
}

export default function CreditsafeLinkSection(props: CreditsafeLinkSectionProps) {
	const { t } = useSettings();

	return (
		<Paper className="rounded-8" variant="outlined">
			<Alert
				className="rounded-8"
				severity="info"
				icon={props.isLoading ? <CircularProgress size={24} disableShrink /> : <Icon icon="info-circle" />}
				action={
					<Tooltip title={t('COMPANIES_CREDITSAFE_BUTTON_LINK')} arrow>
						<IconButton onClick={props.linkCreditsafeCompany}>
							<Icon icon="link-variant" />
						</IconButton>
					</Tooltip>
				}
			>
				<AlertTitle>{t('DETAILS_COMPANIES_CREDITSAFE_SECTION')}</AlertTitle>
				<Typography>{t('DETAILS_COMPANIES_CREDITSAFE_SECTION_DESCRIPTION_NOTLINKED')}</Typography>
				<Typography variant="subtitle2">
					{t('DETAILS_COMPANIES_CREDITSAFE_SECTION_DESCRIPTION_WARNING')}
				</Typography>
			</Alert>
		</Paper>
	);
}
